import { defineMessages } from 'react-intl'
import Validation from '../lib/validation'

export const validateSignUp = (data) => {
  const validator = new Validation(data)
  validator.isRequired('email', messages.emailRequired)
  validator.isEmail('email', messages.emailFormat)
  validator.isRequired('password', messages.passwordRequired)
  validator.isRequired('privacyPolicyAgreement', messages.privacyPolicyAgreementRequired)
  return validator.validate()
}

export const validateTestSignUp = (data) => {
  const validator = new Validation(data)
  validator.isRequired('email', messages.emailRequired)
  validator.isEmail('email', messages.emailFormat)
  validator.isRequired('password', messages.passwordRequired)
  return validator.validate()
}

export const validateTestNameSignUp = (data) => {
  const validator = new Validation(data)
  validator.isRequired('name', messages.nameRequired)
  validator.isRequired('email', messages.emailRequired)
  validator.isEmail('email', messages.emailFormat)
  validator.isRequired('password', messages.passwordRequired)
  validator.isRequired('privacyPolicyAgreement', messages.privacyPolicyAgreementRequired)
  return validator.validate()
}

export const validateSignIn = (data) => {
  const validator = new Validation(data)
  validator.isRequired('email', messages.emailRequired)
  validator.isEmail('email', messages.emailFormat)
  validator.isRequired('password', messages.passwordRequired)
  return validator.validate()
}

export const validateForgotPassword = (data) => {
  const validator = new Validation(data)
  validator.isRequired('email', messages.emailRequired)
  validator.isEmail('email', messages.emailFormat)
  return validator.validate()
}

export const validateChangePassword = (data) => {
  const validator = new Validation(data)
  validator.isRequired('oldPassword', messages.oldPasswordRequired)
  validator.isRequired('newPassword', messages.newPasswordRequired)
  return validator.validate()
}

export const validateResetPassword = (data) => {
  const validator = new Validation(data)
  validator.isRequired('password', messages.emailRepasswordRequiredquired)
  validator.isRequired('passwordConfirm', messages.passwordConfirmRequired)
  validator.isRequired('hash', messages.hashRequired)
  validator.areEqual('password', 'passwordConfirm', messages.passwordsEqual)
  return validator.validate()
}

const messages = defineMessages({
  emailRequired: {
    id: 'validations.auth.emailRequired',
    defaultMessage: 'Email je povinný.',
  },
  passwordRequired: {
    id: 'validations.auth.passwordRequired',
    defaultMessage: 'Heslo je povinné.',
  },
  oldPasswordRequired: {
    id: 'validations.auth.oldPasswordRequired',
    defaultMessage: 'Staré heslo je povinné.',
  },
  newPasswordRequired: {
    id: 'validations.auth.newPasswordRequired',
    defaultMessage: 'Nové heslo je povinné.',
  },
  passwordConfirmRequired: {
    id: 'validations.auth.passwordConfirmRequired',
    defaultMessage: 'Password confirm je povinný.',
  },
  nameRequired: {
    id: 'validations.auth.nameRequired',
    defaultMessage: 'Meno je povinné.',
  },
  hashRequired: {
    id: 'validations.auth.hashRequired',
    defaultMessage: 'Hash je povinný.',
  },
  emailFormat: {
    id: 'validations.auth.emailFormat',
    defaultMessage: 'Nesprávny formát emailu.',
  },
  privacyPolicyAgreementRequired: {
    id: 'validations.auth.privacyPolicyAgreementRequired',
    defaultMessage: 'Súhlas so spracovaním údajov je povinný.',
  },
})



// WEBPACK FOOTER //
// ./src/common/auth/validations.js